import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

// Import CSS và component con
import './HeaderView.css';

import axiosClient from '../../api/axios';
import LinkUpload from '../../api/LinkUpload';

const HeaderView = ({ dataMenus }) => {
    const { isLoggedIn } = useSelector((state) => state.auth);
    const location = useLocation();
    const { pathname } = location;

    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [openSubMenuId, setOpenSubMenuId] = useState(null);
    const [nationalServicePortalLogo, setNationalServicePortalLogo] = useState('');
    const token = localStorage.getItem('token');
    const header = { Authorization: `Bearer ${token}` };

    useEffect(() => {
        const LoadDataBanner = () => {
            axiosClient.post('/Banners/GetBannersAll', {})
                .then(res => {
                    const bannerData = res.data.find(i => i.Position === 'header1');
                    if (bannerData && bannerData.ImageURL) {
                        setNationalServicePortalLogo(LinkUpload(bannerData.ImageURL));
                    }
                })
                .catch(err => console.error("Lỗi khi tải banner:", err));
        };
        LoadDataBanner();
    }, []);

    useEffect(() => {
        const body = document.body;
        if (isMobileMenuOpen) {
            body.classList.add('nav-open');
        } else {
            body.classList.remove('nav-open');
        }
        return () => { body.classList.remove('nav-open'); };
    }, [isMobileMenuOpen]);

    const handleToggleMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMenu = () => {
        setMobileMenuOpen(false);
    };

    const handleNavigate = (url) => {
        window.location.href = url;
    };

    const handleSubMenuToggle = (e, itemId) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenSubMenuId(prevId => (prevId === itemId ? null : itemId));
    };

    return (
        <>
            {/* Thanh banner trên cùng */}
            <div className="header-sticky-wrapper">
                {nationalServicePortalLogo && (
                    <div className="top-bar">
                        <div className="container">
                            <div className="top-bar-layout">
                                <a href="/" onClick={(e) => { e.preventDefault(); handleNavigate('/'); }} className="top-bar__logo">
                                    <img src={nationalServicePortalLogo} alt="Luật sư Lâm Đồng" className="emblem" />
                                </a>
                                <div className="top-bar__actions">
                                    <div className="top-bar__auth-buttons hide-on-mobile">
                                        <a href={isLoggedIn ? '/adminpage' : '/login'}>{isLoggedIn ? 'Quản lý' : 'Đăng nhập'}</a>
                                    </div>
                                    {/* Nút này sẽ vừa là hamburger, vừa là dấu X */}
                                    <button
                                        className="nav-toggle-button hide-on-desktop"
                                        aria-label="Mở/Đóng menu"
                                        aria-expanded={isMobileMenuOpen}
                                        onClick={handleToggleMenu}
                                    >
                                        <span className="hamburger-icon"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Thanh menu chính */}
                <div className="header-wrapper">
                    <header className="container site-header">
                        {/* === LOẠI BỎ NÚT "X" RIÊNG BIỆT KHỎI ĐÂY === */}
                        <nav className="main-nav">
                            {dataMenus && (
                                <CustomMenuNav
                                    data={dataMenus}
                                    openSubMenuId={openSubMenuId}
                                    onNavigate={handleNavigate}
                                    onSubMenuToggle={handleSubMenuToggle}
                                    isLoggedIn={isLoggedIn}
                                    // Truyền thêm hàm closeMenu để menu con có thể đóng toàn bộ menu
                                    onLinkClick={closeMenu}
                                />
                            )}
                        </nav>
                    </header>
                </div>
            </div>
        </>
    );
};

HeaderView.propTypes = {
    dataMenus: PropTypes.array,
};

// Cập nhật lại CustomMenuNav để nhận onLinkClick
const CustomMenuNav = ({ data, openSubMenuId, onNavigate, onSubMenuToggle, isLoggedIn, onLinkClick }) => {
    const handleLinkClick = (e, item) => {
        e.preventDefault();
        const isMobile = window.innerWidth <= 768;
        if (isMobile && item.children && item.children.length > 0 && openSubMenuId !== item.ID) {
            onSubMenuToggle(e, item.ID);
            return;
        }
        if (item.Url) {
            onNavigate(item.Url);
            onLinkClick(); // Đóng menu sau khi điều hướng
        }
    };

    // ... code còn lại của CustomMenuNav giữ nguyên
    const buildTree = (list) => {
        if (!list || list.length === 0) return [];
        const map = {};
        const roots = [];
        list.forEach((item, i) => { map[item.ID] = i; item.children = []; });
        list.forEach(item => {
            if (item.IDParent !== 0 && list[map[item.IDParent]]) {
                list[map[item.IDParent]].children.push(item);
            } else { roots.push(item); }
        });
        roots.unshift({ ID: 'home', Title: 'Trang Chủ', Url: '/', children: [] });
        return roots;
    };

    const renderMenuItems = (menuData) => {
        return menuData.map(item => {
            const hasChildren = item.children && item.children.length > 0;
            const liClassName = [
                hasChildren ? 'has-dropdown' : '',
                openSubMenuId === item.ID ? 'submenu-open' : ''
            ].filter(Boolean).join(' ');

            return (
                <li key={item.ID} className={liClassName}>
                    <a href={item.Url || '#'} onClick={(e) => handleLinkClick(e, item)}>
                        {String(item.Title).toUpperCase()}
                    </a>
                    {hasChildren && <button className="submenu-toggle" onClick={(e) => onSubMenuToggle(e, item.ID)}></button>}
                    {hasChildren && <ul className="sub-menu">{renderMenuItems(item.children)}</ul>}
                </li>
            );
        });
    };

    const menuTree = buildTree(data);

    return (
        <ul>
            {renderMenuItems(menuTree)}
            <li className="mobile-login-button hide-on-desktop">
                <a href={isLoggedIn ? '/adminpage' : '/login'} onClick={(e) => { e.preventDefault(); onNavigate(isLoggedIn ? '/adminpage' : '/login'); onLinkClick(); }}>
                    {isLoggedIn ? 'Quản lý' : 'Đăng nhập'}
                </a>
            </li>
        </ul>
    );
};
CustomMenuNav.propTypes = {
    data: PropTypes.array,
    openSubMenuId: PropTypes.number,
    onNavigate: PropTypes.func.isRequired,
    onSubMenuToggle: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    onLinkClick: PropTypes.func.isRequired,
};

export default HeaderView;